<template>
  <div class="health-settings">
    <div class="form_box">
      <div class="top_title_box">1.温度频率设置</div>
      <div class="row_box_select">
        <el-form-item label="间隔分钟">
          <el-select v-model="form.regionL" placeholder="请选择活动区域">
            <el-option
              :label="item.name"
              :value="item.value"
              v-for="item in list"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
         <!-- <el-switch
          v-model="form.statusShowL"
          active-color="#13ce66"
          inactive-color="#ff4949"
          @change="switchClick()"
        >
        </el-switch> -->
        <span class="right_bottom" @click="saveClick(2, form.regionL)"
          >保存设置</span
        >
        <span class="right_dan" @click="singleTimeClick(2, form.regionL)"
          >单次测量</span
        >
      </div>
      <div class="top_title_box on_top_margin">2.心率频率设置</div>
      <div class="row_box_select">
        <el-form-item label="间隔分钟">
          <el-select v-model="form.regionE" placeholder="请选择活动区域">
            <el-option
              :label="item.name"
              :value="item.value"
              v-for="item in list"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
         
        <span class="right_bottom" @click="saveClick(1, form.regionE)"
          >保存设置</span
        >
        <span class="right_dan" @click="singleTimeClick(1, form.regionE)"
          >单次测量</span
        >
      </div>
      <div class="top_title_box on_top_margin">3.血氧频率设置</div>
      <div class="row_box_select">
        <el-form-item label="间隔分钟">
          <el-select v-model="form.regionR" placeholder="请选择活动区域">
            <el-option
              :label="item.name"
              :value="item.value"
              v-for="item in list"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
         
        <span class="right_bottom" @click="saveClick(4, form.regionR)"
          >保存设置</span
        >
        <span class="right_dan" @click="singleTimeClick(4, form.regionR)"
          >单次测量</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { healthOnOffUpdate,heartRate,measurement } from "@/assets/api/api";
export default {
  data() {
    return {
      form: {
        regionL: 0,
        statusShowL: true,
        regionE: 0,
        regionR: 0,
      },
      list: [
        {
          name: "关闭",
          value: 0,
        },
        {
          name: "5",
          value: 300,
        },
        {
          name: "10",
          value: 600,
        },
        {
          name: "30",
          value: 1800,
        },
        {
          name: "60",
          value: 3600,
        },
        

      ],
      arr: [1,2,4]
    };
  },
  mounted() {
    this.arr.forEach((val) => {
      this.healthFrequency(val)
    });
  },
  methods: {
    singleTimeClick (val,region) {
      console.log("测量");
      let params = {
        day: 1,
        imei : this.$route.query.iemi,
        type: val,
      }
      measurement(params).then((res)=> {
        console.log(res)
        if ( res.data.code == 200 ) {
          this.$message({
            type: "success",
            message: "设置成功!",
          });
        }
      })
    },
    switchClick() {
      console.log("修改");
      // updateStatus(item.id,status).then((res) => {
      //   ElMessage({message: '修改成功',type: 'success',})

      //   this.Getlist()
      // }).catch((err) => {
      // })
    },
    healthFrequency (val) {
      let params = {
        imei : this.$route.query.iemi,
        type : val
      }
      heartRate(params).then((res)=> {
        if ( val == 1 ) {
          this.form.regionE = res.data.data.day
        } else if ( val == 2) {
          this.form.regionL = res.data.data.day
        } else if ( val == 4 ) {
          this.form.regionR = res.data.data.day
        }
      })
    },
    saveClick(val, region) {
      console.log(val, "保存", JSON.parse(localStorage.getItem("user")));
      let params = {
        day : region,
        healthOnOff: region == 0?false:true,
        imei : this.$route.query.iemi,
        type : val,
      };
      healthOnOffUpdate(params).then((res) => {
        console.log(res);
        this.$message({
          type: "success",
          message: "设置成功!",
        });
        // this.healthFrequency()
        this.arr.forEach((val) => {
          this.healthFrequency(val)
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.health-settings {
  height: 95%;
  background-color: #fff;
  padding: 20px;
  .form_box {
    // padding: 20px;
    height: 100%;
    overflow: auto;
    .top_title_box {
      font-size: 24px;
      font-weight: 600;
      margin: 20px 20px;
    }
    .on_top_margin {
      margin-top: 60px;
    }
    .row_box_select {
      display: inline-flex;
      margin-left: 60px;
      .el-form-item--small {
        width: 200px;
      }
      :deep() {
        .el-select--small .el-select__wrapper {
          height: 32px;
        }
        .el-form-item--small .el-form-item__label {
          width: 80px;
          height: 32px;
          line-height: 32px;
          font-size: 16px;
        }
        .el-form-item--small {
          margin-bottom: 0px;
        }
        .el-switch--small .el-switch__core {
          margin-left: 15px;
          width: 40px;
          height: 20px;
          border-radius: 10px;
        }
        .el-switch--small {
          height: 32px;
          line-height: 32px;
        }
      }
      .right_bottom {
        margin-left: 80px;
        border: 1px solid #dcdfe6;
        padding: 2px 10px;
        border-radius: 3px;
        color: #464647;
        cursor: pointer;
      }
      .right_dan {
        margin-left: 80px;
        padding: 2px 10px;
        font-weight: 600;
        color: #464647;
        cursor: pointer;
      }
    }
  }
}
</style>